import { render } from "./ListOfFeaturedAmenitiesPreview.vue?vue&type=template&id=1326aba5&scoped=true"
import script from "./ListOfFeaturedAmenitiesPreview.vue?vue&type=script&lang=js"
export * from "./ListOfFeaturedAmenitiesPreview.vue?vue&type=script&lang=js"

import "./ListOfFeaturedAmenitiesPreview.vue?vue&type=style&index=0&id=1326aba5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1326aba5"]])

export default __exports__